import { RunSettings } from "../services/perspective_api/__generated__/perspective_server-types";

export const runSettinsToId = (runSettings: RunSettings) => {
  return `${runSettings.inputId}-${runSettings.organizationId}-${runSettings.workflowId}-${runSettings.settingsNameAndVersion}-${runSettings.runAttemptId}`;
};
